import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { apiErrorAction } from './actions/apiErrorActions';
import session from 'containers/App/session';

import PropertyHeader from './components/common/headers/propertyHeader';
import Header from './components/common/headers/header';
import Modal from './components/error/modal';
import GoogleAnalytics from 'components/GoogleAnalytics';

import './app.style.css';
import { Outlet } from 'react-router';

const App = ({ children }) => {
    const dispatch = useDispatch();
    const authorisedFeatures = useSelector(session.selectors.selectAccessibleFeatures);
    const user = useSelector(session.selectors.selectUserDetails);
    const status = useSelector((state) => state.apiError && state.apiError.status);

    const onClose = () => {
        dispatch(apiErrorAction({}));
    };

    return (
        <div className="App">
            <Modal show={status >= 500} onClose={onClose}>
                <h1> Server Error</h1>
            </Modal>
            <div style={{ position: 'sticky', top: 0, zIndex: 999 }}>
                <PropertyHeader />
                <Header user={user} authorisedFeatures={authorisedFeatures} />
            </div>

            {children || <Outlet />}
            <GoogleAnalytics />
        </div>
    );
};

export default App;
